import Vue from 'vue'
import Router from 'vue-router'

// 授权查询首页
const key = () => import('@/components/index')

// 查询页面
const search = () => import('@/components/search')

// 换绑页面
const rechange = () => import('@/components/rechange')

// 详情页面
const detail = () => import('@/components/detail')

// 结果页面
const result = () => import('@/components/result')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/key'
    },
    // 授权换绑首页
    {
      path: '/key',
      component: key,
      children: [
        { path: '/', component: search },
        { path: '/search', component: search },
        { path: '/rechange', component: rechange },
        { path: '/detail', component: detail },
        { path: '/result', component: result }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js